import { getAPI } from "@/axios-api";

/**
 * Utility function to format dates for display
 * @param {string} dateString - The date string to format
 * @param {boolean} dateOnly - Whether to show only the date (without time)
 * @returns {Object} Formatted date and time as separate properties
 */
const formatDate = (dateString, dateOnly = false) => {
  const date = new Date(dateString);
  return {
    date: date.toLocaleDateString(),
    time: dateOnly ? null : date.toLocaleTimeString()
  };
};

/**
 * Fetch all groups from the API
 * @returns {Promise<Object>} Object containing raw group data
 */
export async function fetchGroups() {
  try {
    const response = await getAPI.get('groupes/');
    if (response.status === 200) {
      return response.data.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching groups:', error);
    return [];
  }
}

/**
 * Fetch a single group by ID
 * @param {string|number} groupId - The ID of the group to fetch
 * @returns {Promise<Object|null>} The group data or null if not found
 */
export async function fetchGroupById(groupId) {
  try {
    const response = await getAPI.get(`groupes/${groupId}/`);
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error(`Error fetching group with ID ${groupId}:`, error);
    return null;
  }
}

/**
 * Fetch groups with additional metadata for UI display
 * @returns {Promise<Array>} Enhanced group data with metadata
 */
export async function fetchGroupsWithMetadata() {
  try {
    const groups = await fetchGroups();
    
    return groups.map((group, index) => ({
      index: index + 1,
      id: group.id,
      name: group.name,
      userCount: group.users.length,
      lastModified: formatDate(group.updated_at)
    }));
  } catch (error) {
    console.error('Error fetching groups with metadata:', error);
    return [];
  }
}

/**
 * Export the formatDate utility for components that might need it directly
 */
export { formatDate };